import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useSidebarModalMC } from '../../shared/ui/useSidebarModalMC';
import { sharingInformationService } from '../../../../services/sharingInformationService';
import ensureInboxCustomer from '../../../../services/inbox/ensureInboxCustomerService';
import useOrderActionSender from '../../useOrderActionSender';
import useChatAvailability from '../useChatAvailability';

export default function useCustomerOrdersUI({
  reloadOrders,
  conversation,
  customerData
}) {
  const dispatch = useDispatch();
  const { isChatClosed } = useChatAvailability({ conversation });
  const { onSendPdf, onSendPaymentLink } = useOrderActionSender({
    customer: customerData,
    conversation,
    isChatClosed,
    subscribeToEvents: false
  });

  // Hook compartido para sidebar/modal (API simplificada y flexible)
  const { openModal } = useSidebarModalMC({
    refData: {
      onSendPdf,
      onSendPaymentLink,
      customer: customerData,
      channel: conversation?.platform,
      platform: conversation?.platform
    }
  });

  /**
   * Configuración de botón paginación (UI Layer)
   * @type {Object}
   */
  const toggleButtonConfig = useMemo(() => ({
    outlined: true,
    size: 'xs',
    variant: 'SECONDARY',
    className: 'tw-border-0 tw-bg-transparent hover:tw-bg-transparent tw-flex tw-items-center tw-justify-center tw-flex-shrink-0 tw-px-2 tw-py-1',
    iconClassName: '!tw-w-4 !tw-h-4 tw-flex-shrink-0 tw-text-blue-500'
  }), []);

  /**
 * Efecto para suscribirse a eventos de creación de ordenes.
 */
  useEffect(() => {
    const subscription$ = sharingInformationService.getSubject();

    const observable = subscription$.subscribe((data) => {
      if (data.reloadOrders) {
        reloadOrders();
      }
    });

    return () => {
      observable.unsubscribe();
    };
  }, [reloadOrders]);

  const openModalOrder = useCallback(async (props = {}) => {
    let modalProps = props;
    if (props.action === 'new' && conversation) {
      const result = await dispatch(ensureInboxCustomer(conversation));
      if (!result.success) return;
      if (result.customer) {
        modalProps = { ...props, customer: result.customer };
      }
    }
    openModal(modalProps, 'OrderModal', { className: "tw-w-[60vw]" });
  }, [conversation, dispatch, openModal]);

  return useMemo(
    () => ({
      openModalOrder,
      toggleButtonConfig
    }),
    [openModalOrder, toggleButtonConfig]
  );
}
